import { Link } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import { articlesApi } from '../../api/articlesApi';
import { pagesApi } from '../../api/pagesApi';
import { PageHero } from '../../components/ui/PageHero';
import { Seo } from '../../components/ui/Seo';
import './PlanDuSite.css';

const SECTIONS_FIXES = [
  {
    titre: 'Particuliers',
    liens: [
      { to: '/particuliers', label: 'Services à la personne' },
      { to: '/particuliers/faq', label: 'FAQ' },
      { to: '/devis', label: 'Demander un devis' },
    ],
  },
  {
    titre: 'Professionnels',
    liens: [
      { to: '/professionnels', label: 'Solutions professionnelles' },
      { to: '/devis', label: 'Demander un devis' },
    ],
  },
  {
    titre: 'Entreprise',
    liens: [
      { to: '/', label: 'Accueil' },
      { to: '/a-propos', label: 'À propos' },
      { to: '/blog', label: 'Actualités & réalisations' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    titre: 'Informations légales',
    liens: [
      { to: '/mentions-legales', label: 'Mentions légales' },
      { to: '/cgu', label: 'CGU' },
      { to: '/confidentialite', label: 'Politique de confidentialité' },
      { to: '/cookies', label: 'Cookies' },
    ],
  },
];

export function PlanDuSite() {
  const { data: articles } = useFetch(() => articlesApi.list(100, 0), []);
  const { data: pages } = useFetch(() => pagesApi.list(), []);

  const sections = [...SECTIONS_FIXES];

  if (articles?.length) {
    sections.push({
      titre: 'Actualités & réalisations',
      liens: articles.map((a) => ({ to: `/blog/${a.slug}`, label: a.titre })),
    });
  }

  if (pages?.length) {
    sections.push({
      titre: 'Autres pages',
      liens: pages.map((p) => ({ to: `/${p.slug}`, label: p.titre })),
    });
  }

  return (
    <>
      <Seo title="Plan du site" description="Toutes les pages du site AXEO Services Cergy." path="/plan-du-site" />

      <PageHero eyebrow="Navigation" title="Plan du site" subtitle="Toutes les pages du site en un coup d'œil." />

      <section className="section">
        <div className="container">
          <div className="sitemap-grid">
            {sections.map((sec) => (
              <div className="sitemap-col" key={sec.titre}>
                <h2>{sec.titre}</h2>
                <nav>
                  {sec.liens.map((lien) => (
                    <Link key={lien.to} to={lien.to}>
                      {lien.label}
                    </Link>
                  ))}
                </nav>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
